import { createSimpleAction } from '@recruitee/ngrx';

const namespace = 'OfferItems';

const fetchActiveCollections = createSimpleAction(namespace, 'fetchActiveCollections');
const fetchArchivedCollections = createSimpleAction(namespace, 'fetchArchivedCollections');

const actions = {
  fetchActiveCollections,
  fetchArchivedCollections,
};

export { actions as OfferItemsActions };
